import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=50f0b8ee&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=50f0b8ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f0b8ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f0b8ee')) {
      api.createRecord('50f0b8ee', component.options)
    } else {
      api.reload('50f0b8ee', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=50f0b8ee&scoped=true&", function () {
      api.rerender('50f0b8ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sh7aTIf0ruUx/JS/comp/PopupBox.vue"
export default component.exports